import axios from 'axios';
import apiSetting from '../apiSetting';

const API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;

export const employeeLogin = async (email, password) => {
    try {
        const response = await axios.post(`${API_URL}/employees/login`, {
            email,
            password
        });
        return response;
    } catch (error) {
        throw error.response || error;
    }
};

export const employeeLogout = async (token) => {
    const response = await apiSetting({
        method: 'POST',
        url: `${API_URL}/employees/logout`,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};
